import { render } from "./Review.vue?vue&type=template&id=7a5932c8&scoped=true"
import script from "./Review.vue?vue&type=script&lang=js"
export * from "./Review.vue?vue&type=script&lang=js"

import "./Review.vue?vue&type=style&index=0&id=7a5932c8&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7a5932c8"]])

export default __exports__